import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTabContext } from "../contexts/TabContext";

/**
 * 同步浏览器 URL 与标签页状态
 * - 当用户在页面内通过 Link/navigate 跳转时，将新路径添加为标签
 * - 当切换标签时，更新浏览器 URL
 */
const LocationSync = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { addOrSwitchTab, tabs, activeTabId, pathToLabel } = useTabContext();
  const isInternalSwitchRef = useRef(false);

  const activeTab = tabs.find((t) => t.id === activeTabId);

  useEffect(() => {
    const path = location.pathname === "/" ? "/dashboard" : location.pathname;

    if (isInternalSwitchRef.current) {
      isInternalSwitchRef.current = false;
      return;
    }

    addOrSwitchTab(path, pathToLabel(path));
  }, [location.pathname, addOrSwitchTab, pathToLabel]);

  useEffect(() => {
    if (!activeTab || activeTab.path === location.pathname) return;

    isInternalSwitchRef.current = true;
    navigate(activeTab.path);
  }, [activeTabId, activeTab, location.pathname, navigate]);

  return null;
};

export default LocationSync;
